export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1775116483675-a592e6e02807?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  craftsman: "https://images.pexels.com/photos/5768284/pexels-photo-5768284.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  window: "https://images.unsplash.com/photo-1591474200742-8e512e6f98f8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  sun: "https://images.unsplash.com/photo-1766087752966-b9a7b058b7da?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  facade: "https://images.unsplash.com/photo-1619218070141-bcfeb8b93074?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  terrace: "https://images.unsplash.com/photo-1697609709300-d7409f2c2459?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  before: "https://images.pexels.com/photos/5768284/pexels-photo-5768284.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  after: "https://images.unsplash.com/photo-1591474200742-8e512e6f98f8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};
